window.addEventListener("DOMContentLoaded", () => {
  if (document.getElementById('map-container')) {
    const mapContainer = document.getElementById('map-container'),
      lat = mapContainer.dataset.lat,
      lng = mapContainer.dataset.lng,
      zoom = mapContainer.dataset.zoom;

    mapboxgl.accessToken = 'pk.eyJ1Ijoia2VubnlkZnd1IiwiYSI6ImNrZ3RqYjlvdzAxbmcycXJ5bGdmZjkyMDcifQ.hFqpaCAVX5zzJ_nOv5IvTQ';
    var map = (window.map = new mapboxgl.Map({
      container: 'map-container',
      zoom: zoom,
      center: [lng, lat],
      style: 'mapbox://styles/mapbox/light-v10',
      antialias: true // create the gl context with MSAA antialiasing, so custom layers are antialiased
    }));
  
    var geojson = {
      type: 'FeatureCollection',
      features: [{
        type: 'Feature',
        geometry: {
          type: 'Point',
          coordinates: [lng, lat]
        },
        properties: {
          title: 'Mapbox',
          description: 'Paris'
        }
      }]
    };
  
    // add markers to map
    geojson.features.forEach(function (marker) {
  
      // create a HTML element for each feature
      var el = document.createElement('div');
      el.className = 'marker';
  
      // make a marker for each feature and add to the map
      new mapboxgl.Marker(el)
        .setLngLat(marker.geometry.coordinates)
        .addTo(map);
    });
  }
});